import {SearchModelBase} from './SearchModelBase';
import * as XCol from '../../framework.core/XExportColumn';
import _ from 'lodash';

export class Payroll2ListItem extends SearchModelBase {
    payrollDate: string | null = null;
    fromPayrollDate: string | null = null;
    toPayrollDate: string | null = null;
    payrollNo: string = '';
    branch: string = '';

    grossAmt: number|null = null;
    fromGrossAmt: number|null = null;
    toGrossAmt: number|null = null;

    netPayAmt: number|null = null;
    fromNetPayAmt: number|null = null;
    toNetPayAmt: number|null = null;

    fedTaxAmt: number|null = null;
    fromFedTaxAmt: number|null = null;
    toFedTaxAmt: number|null = null;

    fedUnemployAmt: number|null = null;
    fromFedUnemployAmt: number|null = null;
    toFedUnemployAmt: number|null = null;

    stateTaxAmt: number|null = null;
    fromStateTaxAmt: number|null = null;
    toStateTaxAmt: number|null = null;

    stateUnemployAmt: number|null = null;
    fromStateUnemployAmt: number|null = null;
    toStateUnemployAmt: number|null = null;

    netPayPaid: number|null = null;
    fedTaxPaid: number|null = null;
    fedUnemployPaid: number|null = null;
    stateTaxPaid: number|null = null;
    stateUnemployPaid: number|null = null;

    void: boolean = false;
    voidDate: string | null = null;
    fromVoidDate: string | null = null;
    toVoidDate: string | null = null;
    remark: string = '';
    modifiedAt: string | null = null;
    fromModifiedAt: string | null = null;
    toModifiedAt: string | null = null;
    createdAt: string | null = null;
    fromCreatedAt: string | null = null;
    toCreatedAt: string | null = null;
    modifiedBy: string = '';
    createdBy: string = '';
    blank: string = '';
    id: number = 0;
    allPaid: boolean = false;

    private static ExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: '', width: 30, dataIndex: 'status', hiddenInColumnSetup: true}),
        XCol.Create({ col: 1, text: 'Date', width: 75, dataIndex: 'payrollDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 2, text: 'Ref. #', width: 100, dataIndex: 'payrollNo', defaultColumnFocus : true}),
        XCol.Create({ col: 3, text: 'BR', width: 40, dataIndex: 'branch', align: XCol.XAlignType.Center}),
        XCol.Create({ col: 4, text: 'GROSS SALARY', width: 100, dataIndex: 'grossAmt', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0.00', noNullOrEmptySearch: true }),
        XCol.Create({ col: 5, text: 'NET PAYMENT', width: 100, dataIndex: 'netPayAmt', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0.00', noNullOrEmptySearch: true }),
        XCol.Create({ col: 6, text: 'Paid', width: 40, dataIndex: 'netPayPaid',  type: XCol.XCellType.Bool, align: XCol.XAlignType.Center, noNullOrEmptySearch: true}),
        XCol.Create({ col: 7, text: 'FED - TAX', width: 100, dataIndex: 'fedTaxAmt', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0.00', noNullOrEmptySearch: true }),
        XCol.Create({ col: 8, text: 'Paid', width: 40, dataIndex: 'fedTaxPaid', type: XCol.XCellType.Bool, align: XCol.XAlignType.Center, noNullOrEmptySearch: true}),
        XCol.Create({ col: 9, text: 'FED - UNEMPLOY', width: 100, dataIndex: 'fedUnemployAmt', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0.00', noNullOrEmptySearch: true }),
        XCol.Create({ col: 10, text: 'Paid', width: 40, dataIndex: 'fedUnemployPaid',  type: XCol.XCellType.Bool, align: XCol.XAlignType.Center, noNullOrEmptySearch: true}),
        XCol.Create({ col: 11, text: 'STATE - TAX', width: 100, dataIndex: 'stateTaxAmt', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0.00', noNullOrEmptySearch: true }),
        XCol.Create({ col: 12, text: 'Paid', width: 40, dataIndex: 'stateTaxPaid',  type: XCol.XCellType.Bool, align: XCol.XAlignType.Center, noNullOrEmptySearch: true}),
        XCol.Create({ col: 13, text: 'STATE - UNEMPLOY', width: 100, dataIndex: 'stateUnemployAmt', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0.00', noNullOrEmptySearch: true }),
        XCol.Create({ col: 14, text: 'Paid', width: 40, dataIndex: 'stateUnemployPaid',  type: XCol.XCellType.Bool, align: XCol.XAlignType.Center, noNullOrEmptySearch: true}),
        // XCol.Create({ col: 15, text: 'V', width: 40, dataIndex: 'void', type: XCol.XCellType.Bool, align: XCol.XAlignType.Center, noNullOrEmptySearch: true, visible: false}),
        // XCol.Create({ col: 16, text: 'Void Date', width: 75, dataIndex: 'voidDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 17, text: 'Remark', width: 150, dataIndex: 'remark'}),
        XCol.Create({ col: 18, text: 'Create Date', width: 100, dataIndex: 'createdAt', type: XCol.XCellType.DateTime, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 19, text: 'Create by', width: 80, dataIndex: 'createdBy'}),
        XCol.Create({ col: 20, text: 'Update Date', width: 100, dataIndex: 'modifiedAt', type: XCol.XCellType.DateTime, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 21, text: 'Update by', width: 80, dataIndex: 'modifiedBy'}),
    ];

    public static getExportCollection(useBranch: boolean): XCol.XExportColumn[] {
        let returnCloumns = _.cloneDeep(this.ExportCollection);
        if (!useBranch) returnCloumns = returnCloumns.filter(x => x.dataIndex !== 'branch');
        return returnCloumns;
    };
	
    public static OrderBy = { orderBy: Payroll2ListItem.prototype.id, orderByAscending: false };

    public static formatData(data: Payroll2ListItem[]) {
        return data.map((d: Payroll2ListItem) => ({
          ...d,
        }));
    }

    public static MapSearchFields: {[key: string]: {[key: string]: string}} = {
        payrollDate: {from: 'fromPayrollDate', to: 'toPayrollDate'},
        voidDate: {from: 'fromVoidDate', to: 'toVoidDate'},
        createdAt: {from: 'fromCreatedAt', to: 'toCreatedAt'},
        modifiedAt: {from: 'fromModifiedAt', to: 'toModifiedAt'},
        grossAmt: {from: 'fromGrossAmt', to: 'toGrossAmt'},
        netPayAmt: {from: 'fromNetPayAmt', to: 'toNetPayAmt'},
        fedTaxAmt: {from: 'fromFedTaxAmt', to: 'toFedTaxAmt'},
        fedUnemployAmt: {from: 'fromFedUnemployAmt', to: 'toFedUnemployAmt'},
        stateTaxAmt: {from: 'fromStateTaxAmt', to: 'toStateTaxAmt'},
        stateUnemployAmt: {from: 'fromStateUnemployAmt', to: 'toStateUnemployAmt'},
    }
}
